<template>
  <v-container fluid grid-list-xl page>
    <!-- Your contet -->

    <div class="display-2 grey--text text--darken-1">
      Características del Producto
    </div>
    <div class="title grey--text text--darken-1"></div>

    <v-layout>
      <v-flex>
        <v-card class="justify-center">
          <v-container fluid grid-list-md>
            <v-layout row wrap class="justify-center">
              <v-flex xs12 md6 lg3 offset-2>
                <v-card flat tile>
                  <v-img
                    justify-center
                    src="/static/send.png"
                    width="100"
                    aspect-ratio="1"
                  ></v-img>

                  <v-card-title primary-title>
                    <div>
                      <h3 class="headline mb-0">Fácil Integración</h3>
                      <div>
                        Su API REST permite la intagración sencilla con otras
                        soluciones, tanto para iniciar proceesos de firma como
                        para obtener información. La integración se puede
                        realizar tanto a nivel de fornt-end como de back-end.
                      </div>
                    </div>
                  </v-card-title>
                  <v-card-actions>
                    <v-btn
                      flat
                      round
                      color="orange darken-4"
                      dark
                      bold
                      outline
                      @click="goApi()"
                      >Ver Más</v-btn
                    >
                    <!--  <v-btn flat color="orange" to="/blank-page" >Legal</v-btn> -->
                  </v-card-actions>
                </v-card>
              </v-flex>

              <!-- --------- -->

              <v-flex xs12 md6 lg3>
                <v-card flat tile>
                  <v-img
                    src="/static/digital-signature.png"
                    width="100"
                    aspect-ratio="1"
                  ></v-img>

                  <v-card-title primary-title xs12 sm3>
                    <div>
                      <h3 class="headline mb-0">Personalizable</h3>
                      <div>
                        Puedes componer una solución a medida utilizando los
                        componentes quee elijas: firma electrónica de diversos
                        tipos , OCR, biometría facial...
                      </div>
                    </div>
                  </v-card-title>

                  <!-- <v-card-actions>
                    <v-btn flat color="orange">Learn More</v-btn>
                  </v-card-actions> -->
                </v-card>
              </v-flex>

              <v-flex xs12 md6 lg3>
                <v-card flat tile>
                  <v-img
                    s
                    src="/static/2devices.png"
                    width="100"
                    aspect-ratio="1"
                  ></v-img>

                  <v-card-title primary-title xs12 sm3>
                    <div>
                      <h3 class="headline mb-0">
                        Multicanal y Multidispositivo
                      </h3>
                      <div>
                        Se puedes firmar o identificarse utilizando cualquier
                        dispositivo ( PC, móvil o tablet ) en persona o de forma
                        remota manteniendo las máximas garantías.
                      </div>
                    </div>
                  </v-card-title>

                  <!-- <v-card-actions>
                    <v-btn flat color="orange">Share</v-btn>
                    <v-btn flat color="orange">Learn More</v-btn>
                  </v-card-actions> -->
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
    <v-spacer></v-spacer>

    <v-layout height="100">
      <v-card height="100" flat color="grey"> </v-card>
    </v-layout>

    <v-layout>
      <v-flex>
        <v-card class="justify-center">
          <v-container fluid grid-list-md>
            <v-layout row wrap class="justify-center">
              <v-flex xs12 md6 lg3 offset-2>
                <v-card flat tile>
                  <v-img
                    justify-center
                    src="/static/ui.png"
                    width="100"
                    aspect-ratio="1"
                  ></v-img>

                  <v-card-title primary-title>
                    <div>
                      <h3 class="headline mb-0">
                        Diseño optimizado y adaptable
                      </h3>
                      <div>
                        Productos orientados a obtener la mayor usabilidad:
                        funcionalidad máxima con un mínimo de pasos, asegurando
                        el cumplimiento de normativas.
                      </div>
                    </div>
                  </v-card-title>

                  <v-card-actions> </v-card-actions>
                </v-card>
              </v-flex>

              <!-- --------- -->

              <v-flex xs12 md6 lg3>
                <v-card flat tile>
                  <v-img
                    src="/static/transparencia.png"
                    width="100"
                    aspect-ratio="1"
                  ></v-img>

                  <v-card-title primary-title xs12 sm3>
                    <div>
                      <h3 class="headline mb-0">Transparencia</h3>
                      <div>
                        Con nuestras soluciones dispones de una herramienta de
                        back-office con la que se puede hacer seguimiento en
                        tiempo real del estado de las operaciones y aplicar
                        reglas de negocio personalizadas.
                      </div>
                    </div>
                  </v-card-title>

                  <v-card-actions> </v-card-actions>
                </v-card>
              </v-flex>

              <v-flex xs12 md6 lg3>
                <v-card flat tile>
                  <v-img
                    s
                    src="/static/legal.png"
                    width="100"
                    aspect-ratio="1"
                  ></v-img>

                  <v-card-title primary-title xs12 sm3>
                    <div>
                      <h3 class="headline mb-0">Validez Legal</h3>
                      <div>
                        Las firmas electrónicas de documentos realizadas en
                        Securyty cumpleen los requisitos legales in la UE y USA.
                        Adicionalmnte, Securyty firma electrónicamentee todos
                        los eventos además de aplicarles un sellado de tiempo
                        para dejar constancia de las acciones a nivel de
                        auditoría.
                      </div>
                    </div>
                  </v-card-title>

                  <v-card-actions>
                    <v-btn
                      round
                      color="orange darken-4"
                      dark
                      bold
                      outline
                      @click="goToLegal"
                      >Ver Más</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="isCreateSign" persistent max-width="500px">
      <v-card>
        <v-toolbar color="orange" dark>
          <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
          <v-toolbar-title>Create New Identification </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip right>
            <v-icon slot="activator" color="white" dark>help_outline</v-icon>
            <span
              ><b
                >Identity Verification : <br /><br />- Identify through a video,
                view the result and sign a document with the data extracted from
                the identification</b
              ><br /><br />
            </span>
          </v-tooltip>
        </v-toolbar>
        <create-sign-video-page
          :scroll-top="scrollTop"
          signature-type="video"
        ></create-sign-video-page>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="closeSignaturePage"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import CreateSignVideoPage from "./CreateSignVideoPage";

export default {
  components: {
    CreateSignVideoPage
  },
  beforeCreate() {
    window.scrollTo(0, 0);
  },
  // mounted() {
  //   // Google Analytics
  //   this.$ga.page(this.$router);
  // },
  data() {
    return {
      isCreateSign: false,
      page: {
        title: "Key Features ",
        headline: "Key Features",
        description: `Automate your on-boarding process`
      },
      breadcrumbs: [
        {
          text: "Src",
          disabled: false
        },
        {
          text: "Views",
          disabled: false
        },
        {
          text: "Blank",
          disabled: false
        }
      ],
      scrollTop: 0
    };
  },
  methods: {
    createSignature() {
      //this.$router.push("CreateSignPage")
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      document.getElementsByTagName("body")[0].className = "noscroll";
      this.isCreateSign = true;
    },
    closeSignaturePage() {
      document.body.removeAttribute("class", "noscroll");
      window.scrollTo(0, this.scrollTop);
      this.isCreateSign = false;
    },
    goToLegal() {
      this.$router.push({ name: "legalInformationEs" });
    },
    goApi() {
      this.$router.push({ name: "ApiPageEs2" });
    }    
  }
};
</script>
